import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  TableBody,
} from "@mui/material";
import { useGetEvaluationByProfileIdQuery } from "../../redux/api/evaluation";
import { useEffect, useState } from "react";
import { Evaluation, EvaluationStatus } from "../../common/Evaluation";
import { NavLink, useParams } from "react-router-dom";
import { formatDateString } from "../../common/FormatDateString";

const ProfileEvaluations = () => {
  const { id } = useParams();
  const {
    data: evaluationsFromApi,
    isLoading,
    isFetching,
  } = useGetEvaluationByProfileIdQuery(id as string);
  const [evaluations, setEvalulations] = useState<Evaluation[]>([]);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      const evalList: Evaluation[] = evaluationsFromApi!;
      setEvalulations(evalList);
    }
  }, [evaluationsFromApi, isLoading, isFetching, id]);

  const formatMonthYear = (dateString: string | undefined) => {
    if (!!dateString) {
      let date = new Date(dateString);
      if (date instanceof Date && !isNaN(date.valueOf())) {
        const offsetDate = new Date(
          date.getTime() - date.getTimezoneOffset() * -60000
        );
        return new Intl.DateTimeFormat("en-GB", {
          year: "numeric",
          month: "short",
        }).format(offsetDate);
      } else {
        return "";
      }
    }
    return "";
  };

  return (
    <>
      {!isLoading && !isFetching && !!evaluations && (
        <div>
          <h3 className="mb-0">Performance Evaluation</h3>
          {evaluations.length > 0 ? (
            <TableContainer>
              <Table className="documents-table">
                <TableHead>
                  <TableRow>
                    <TableCell className="small-field">DATE</TableCell>
                    <TableCell className="medium-field">EVALUATION</TableCell>
                    <TableCell className="medium-field">STATUS</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {evaluations.map((evaluation) => (
                    <TableRow key={evaluation.id}>
                      <TableCell>
                        {formatMonthYear(evaluation.fromDate)}
                      </TableCell>
                      <TableCell>
                        <NavLink
                          to={`/evaluations/${evaluation.id}`}
                          className="blue-link justify-content-start"
                        >
                          Performance Evaluation{" "}
                          {formatMonthYear(evaluation.fromDate)}
                        </NavLink>
                      </TableCell>
                      <TableCell>
                        {evaluation.status &&
                        evaluation.status ===
                          EvaluationStatus.SENIOR_OFFICER_SIGN
                          ? `Signed: ${formatDateString(
                              evaluation.evaluateeSignature?.signatureDate!
                            )}`
                          : ""}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <p style={{ marginTop: "10px" }}>
              No Performance Evaluations to Display
            </p>
          )}
        </div>
      )}
    </>
  );
};

export default ProfileEvaluations;
